module.exports = __webpack_public_path__ + "assets/img/thumb-Australian-Institute-of-Fitness-Website.4e818164.jpg";